import { motion } from "framer-motion";
import { Trophy, Star } from "lucide-react";

export const Leaderboard = ({ applicants, onOpen }) => {
  const top = [...applicants].sort((a, b) => b.votes - a.votes).slice(0, 5);
  if (top.length === 0) return null;
  return (
    <div className="mt-12 border border-[#D4AF37]/25 bg-[#0A0E14] overflow-hidden" data-testid="leaderboard">
      <div className="flex items-center justify-between px-5 md:px-6 py-3 border-b border-[#D4AF37]/20">
        <p className="flex items-center gap-2 text-[10px] tracking-[0.4em] uppercase text-[#D4AF37]">
          <Trophy size={13} /> Closest to a berth
        </p>
        <p className="font-coords text-[9px] tracking-[0.25em] text-[#94A3B8]">LIVE · BY VOTES</p>
      </div>
      <ol className="divide-y divide-[#D4AF37]/10 md:divide-y-0 md:grid md:grid-cols-5">
        {top.map((a, i) => (
          <motion.li key={a.id} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }} className="md:border-r md:last:border-r-0 border-[#D4AF37]/10">
            <button onClick={() => onOpen(a)} className="w-full text-left flex items-center gap-4 px-5 md:px-6 py-4 hover:bg-[#D4AF37]/5 transition-colors duration-300"
              data-testid={`leaderboard-rank-${i + 1}`}>
              <span className={`font-display text-2xl leading-none ${i === 0 ? "gold-text" : "text-[#D4AF37]/40"}`}>{String(i + 1).padStart(2, "0")}</span>
              <span className="min-w-0 flex-1">
                <span className="block font-display text-sm tracking-[0.06em] text-[#F5F3EF] truncate">{a.name}</span>
                <span className="block font-coords text-[9px] tracking-[0.2em] uppercase text-[#94A3B8] truncate">{a.role}</span>
              </span>
              <span className="flex items-center gap-1 font-coords text-[11px] text-[#E8C15A] shrink-0" data-testid={`leaderboard-votes-${i + 1}`}>
                <Star size={11} /> {a.votes}
              </span>
            </button>
          </motion.li>
        ))}
      </ol>
    </div>
  );
};
